module.exports = __webpack_public_path__ + "img/potencia_r_b.5402edc7.svg";